var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"id":"share-links"}},[_c('span',{staticStyle:{"margin-right":"6px"}},[_c('a',{staticClass:"twitter-share-button",attrs:{"href":_vm.shareURL,"data-show-count":"false"}},[_vm._v("Tweet")])]),_vm._v("   ")])}
var staticRenderFns = []

export { render, staticRenderFns }